import { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import { LoadingPage } from 'Pages';

const IdpInitiatedLogin = () => {
  const { loginWithRedirect } = useAuth0();
  const started = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (started.current) return;

    started.current = true;
    loginWithRedirect().catch(() => setError(true));
  }, [loginWithRedirect]);

  return (
    <LoadingPage
      message={
        error
          ? 'Unable to start single sign-on. Please return to your identity provider and try again.'
          : 'Starting single sign-on...'
      }
    />
  );
};

export default IdpInitiatedLogin;
